import React, { useEffect } from "react";
import { useController } from "react-hook-form";
import Card from "../../components/Card/Card";
import CardBody from "../../components/Card/CardBody";
import { Grid, Typography } from "@mui/material";
import { Cron } from "react-js-cron";
import "./cron-ant.css";
import FormSwitchTC from "../../components/Forms/FormSwitchTC";
import FormJson from "../../components/Forms/FormJson";
import FormAsyncTC from "../../components/Forms/FormAsyncTC";
import { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import EmailAdresses from "./EmailAdresses";

function Algemeen() {
  const {
    field: { value: cronConfigValue, onChange: cronConfigOnChange },
  } = useController({ name: "cron_config" });
  useEffect(() => {
    if (!cronConfigValue) {
      cronConfigOnChange("0 4 * * *");
    }
  }, []);
  return (
    <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
      <Card>
        <CardBody style={{ padding: 16 }}>
          <Typography>{cronConfigValue}</Typography>

          <FormSwitchTC name={"active"} tDefault={"Active"} tKey={"scheduled_tasks.Active"} />
          <FormAsyncTC
            async={{
              url: "core/scheduledTasks/listTaskNames",
              searchField: "",
            }}
            name={"task_name"}
            rules={{ required: { value: true, message: getTranslation("This field is required!") } }}
            tDefault={"Task name"}
            tKey={"scheduled_tasks.Task name"}
          />

          <FormSwitchTC
            name={"notify_slack_on_failure"}
            tDefault={"Notify on slack channel #devs?"}
            tKey={"scheduled_tasks.Notify on slack channel"}
          />

          <Cron
            setValue={(v) => {
              cronConfigOnChange(v);
            }}
            value={cronConfigValue}
          />

          <Grid container spacing={1}>
            <FormJson name={"json_parameters"} tDefault={"Parameters"} tKey={"scheduled_tasks.Json parameters"} />
          </Grid>

          <EmailAdresses />
        </CardBody>
      </Card>
    </div>
  );
}

export default Algemeen;
